export const FREE_AGENCY_AD_INSERT_NUMBER = 12
export const TRANSACTIONS_AD_INSERT_NUMBER = 35
export const CONTRACT_AD_INSERT_NUMBER = 12

export const shouldShowAd = (indexNum: number, insertNumber: number) => {
    if (indexNum !== 0 && indexNum % insertNumber === 0) {
      return true
    }
    return false
  }